<script>
    import { closeModal } from 'svelte-modals';
    import Carousel from 'svelte-carousel';

    // provided by <Modals />
    export let isOpen;

    let carousel; // for calling methods of the carousel instance
    const handleNextClick = () => {
        carousel.goToNext();
    };

    export let carouselImages;
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents">
            <div class="actions">
                <div class="delete-button" on:click={closeModal}>
                    <i class="fas fa-times" />
                </div>
            </div>
            <div
                id="carouselExampleIndicators"
                class="carousel slide"
                data-ride="carousel"
                data-interval="false"
            >
                <ol class="carousel-indicators">
                    {#each carouselImages as image, i}
                        <li
                            data-target="#carouselExampleIndicators"
                            data-slide-to={i}
                            class={i === 0 ? 'active' : ''}
                        />
                    {/each}
                </ol>
                <div class="carousel-inner" style="width: 600px">
                    {#each carouselImages as image, i}
                        <div class="carousel-item {i === 0 ? 'active' : ''}">
                            <img
                                class="d-block w-100"
                                src={image}
                                alt="First slide"
                            />
                        </div>
                    {/each}
                </div>
                <a
                    class="carousel-control-prev"
                    href="#carouselExampleIndicators"
                    role="button"
                    data-slide="prev"
                >
                    <span
                        class="carousel-control-prev-icon"
                        aria-hidden="true"
                    />
                    <span class="sr-only">Previous</span>
                </a>
                <a
                    class="carousel-control-next"
                    href="#carouselExampleIndicators"
                    role="button"
                    data-slide="next"
                >
                    <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"
                    />
                    <span class="sr-only">Next</span>
                </a>
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .carousel-item {
        background-color: white;
        width: 100%;
        height: 600px;
    }

    .carousel-item img {
        object-fit: contain;
        width: 100%;
        height: 100%;
    }

    .contents {
        min-width: 240px;
        max-width: 800px;
        border-radius: 6px;
        padding: 16px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        pointer-events: auto;
    }

    h2 {
        text-align: center;
        font-size: 24px;
    }

    p {
        text-align: center;
        margin-top: 16px;
    }

    .actions {
        margin: 10px;
        display: flex;
        justify-content: flex-end;
    }
    .actions i {
        font-size: 15px;
    }
</style>
